export interface Faq {
  question: string;
  answer: string;
}

export const faqs: Faq[] = [
  // {
  //   question: 'Can I change my plan later?',
  //   answer:
  //     'Yes, you can upgrade or downgrade your plan at any time. Changes will be reflected in your next billing cycle.',
  // },
  {
    question: 'Do you offer refunds?',
    answer:
      "We offer a 14-day money-back guarantee for all plans. If you're not satisfied, we'll refund your payment. Contact us via the contact form in the bottom right of the page.",
  },
  {
    question: 'What payment methods do you accept?',
    answer:
      'We accept all major credit and debit cards, digital wallets, and bank transfers. We process payment using Stripe.',
  },
  {
    question: 'There is this feature which I want but cannot find it',
    answer:
      'We are constantly adding new features. If you have a feature request, please contact us via the contact form in the bottom right of the page.',
  },
  // {
  //   question: 'Is there a free trial?',
  //   answer: 'Yes, we offer a 7-day free trial for all plans. No credit card required to start.',
  // },
  {
    question: 'Can I cancel anytime?',
    answer:
      "Yes, you can cancel your subscription at any time. You'll continue to have access until the end of your billing period.",
  },
];
